// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_rdE","cls2":"WorkCard-cls2_Qkk WorkCard-cls1_rdE"};